module.exports = __webpack_public_path__ + "img/write-message_white.a5b7867b.svg";